// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/MobileBasketSummary/MobileBasketSummary.css
// module id = 1196
// module chunks = 0